import script from "./sidebar-file-attachments.vue?vue&type=script&setup=true&lang=ts"
export * from "./sidebar-file-attachments.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__